import type { ShortTextQuestion } from '@shared/domain/form';
import React from 'react';
import ErrorMessage from '@shared/components/ErrorMessage';
import { StyledTextField } from '../../styles/review.styles';
import {
  AnswerWrapper,
  BaseQuestionText,
  BaseQuestionTextWrapper,
  BaseQuestionWrapper,
} from './shared/QuestionStyles';

interface ReviewShortQuestionProps {
  question: ShortTextQuestion;
  formFields: Record<string, any>;
  handleFormFieldChange: (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
  errors: Record<string, string>;
}

function ReviewShortTextQuestion(props: ReviewShortQuestionProps) {
  const { question, formFields, handleFormFieldChange, errors } = props;

  return (
    <BaseQuestionWrapper data-error-name={question.name} data-testid={question.name}>
      <BaseQuestionTextWrapper>
        <BaseQuestionText>{question.question}</BaseQuestionText>
      </BaseQuestionTextWrapper>
      <AnswerWrapper $width="80%">
        <StyledTextField
          name={question.name}
          onChange={handleFormFieldChange}
          value={formFields[question.name] || ''}
          size="small"
        />
        {errors[question.name] && (
          <ErrorMessage error={errors[question.name]} />
        )}
      </AnswerWrapper>
    </BaseQuestionWrapper>
  );
}

export default ReviewShortTextQuestion;
